/**
 * Centralized text and copy for WINGO World Wapped
 */

export const wrappedCopy = {
  title: {
    main: 'WINGO World Wapped',
    subtitle: 'A 320 Track Club Experience',
  },

  cards: {
    initiation: {
      title: 'You entered WINGO World on',
      honeymoon: "You're still in the honeymoon lap.",
    },
    totalMined: {
      title: 'WINGO Mined (2025)',
      distance: 'That\'s {km} km of Wingos',
    },
    highestSession: {
      title: 'Your Top Mining Session',
    },
    wingoPerSession: {
      title: 'On a Typical Visit, You Mined {avg} WINGO',
      steady: 'Steady',
      spiky: 'Spiky',
      emotionallyVariable: 'Emotionally Variable',
    },
    tenPlusOne: {
      completed: 'You Completed the WINGO World 10+1 Program, Unlocking the Old Balance Wingate Invitational',
      notCompleted: "You Flirted with the Gate. DAISY Is Still Waiting.",
    },
    wagers: {
      noWagers: "You Refused to Gamble.",
      hasWagers: "You Tested DAISY's Odds {count} Times. DAISY Remembers All of Them.",
      degenerateDashboard: "DAISY's Degenerate Dashboard",
      wingoWorldWagers: "WINGO World Wagers",
    },
    specialUnlocks: {
      obwiPrize: 'OBWI 10+1',
      yellowstone: "DAISY's Yellowstone Adventure",
      dancingDaisy: "DAISY's Yellowstone Adventure",
    },
    oldBalance: {
      title: 'OLD BALANCE™',
      tagline: 'Because stability is suspicious.',
      sponsored: 'Sponsored content.',
      continue: 'Continue Wrapped',
    },
    daisyTrust: {
      title: 'DAISY Trust Score™',
      verdict: 'DAISY considers you a {label}.',
    },
    nextYear: {
      highMinedLowTrust: 'Projected: Fewer WINGO, More Questions.',
      moderateMinedHighTrust: 'Projected: 58.3% More Stubborn Consistency.',
    },
  },

  daisyTrustLabels: {
    trustedMare: 'Trusted Mare',
    mostlyReliable: 'Mostly Reliable',
    chaoticNeutral: 'Chaotic Neutral',
    statisticalProblem: 'Statistical Problem',
  },
};

